// extracted by mini-css-extract-plugin
export default {"button":"button_button__zpxkc","buttonDisabled":"button_buttonDisabled__8C4dC"};